import { Component, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';


import { MateriaisService } from '../../../../providers/materiais-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

declare var jsPDF: any;

@Component({
  selector: 'page-materiais-consumo',
  templateUrl: 'materiais-consumo.html',
  providers: [
    MateriaisService
  ]
})
export class MateriaisConsumoPage extends ModulosController {
  listaDados: any = [];
  loading: boolean = true;
  idSecaoPagina: string = "161";
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];
  totalValorContabil = 0;
  totalValorAquisicoes = 0;
  totalValorConsumo = 0;
  totalValorContabilFinal = 0;


  relatorioParaAdicionar: any = {
    valorContabil: '',
    valorContabilFinal: '',
    valorAquisicoes: '',
    valorConsumo: '',
    item: '',
    codigoConta: '',
    descricaoConta: '',
    idModuloAnalise: ''
  }

  page1: number = 1;

  objetoEdit: any = null;
  listEdit: any = [];
  analise: any = null;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  selecionarTodosChecked = false;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public materiaisService: MateriaisService,
    private fileService: FileService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.carregarDados();
    this.setModuloId(13);
  }

  carregarDados() {
    this.materiaisService.listarMateriaisConsumo().subscribe(data => {
      this.listaDados = data;      
      this.totalizarValores(); 
      this.selecionarTodosChecked = false;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });

  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        this.loading = true;
        this.fileService.cargaInventarioMaterialConsumo(event, this.idSecaoPagina).subscribe(data => {
          this.inputFileCMVar.nativeElement.value = "";

          this.dadosImportados = data;

          for (let j = 0; j < this.dadosImportados.length; j++) {       
            this.listaDados.push(this.dadosImportados[j]);
          } 

          this.totalizarValores();

          this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");         
          this.loading = false;
          
        }, error => {
          this.inputFileCMVar.nativeElement.value = "";
          this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
          this.loading = false;
        });
      } else {
        this.inputFileCMVar.nativeElement.value = "";
      }
    });
  }

  downloadDoModelo() {
    this.fileService.downloadModeloCargaGestaoMateriais(this.idSecaoPagina);
  }

  atualizaValorContabilAtual() {
    this.relatorioParaAdicionar.valorContabilFinal = (this.relatorioParaAdicionar.valorContabil + this.relatorioParaAdicionar.valorAquisicoes) - this.relatorioParaAdicionar.valorConsumo;
  }

  adicionarRelatorio() {

    if (this.relatorioParaAdicionar.item != '' &&
      this.relatorioParaAdicionar.codigoConta != '' &&
      this.relatorioParaAdicionar.descricaoConta != '') {

      if (this.relatorioParaAdicionar.valorContabil == "" || this.relatorioParaAdicionar.valorContabil == null || this.relatorioParaAdicionar.valorContabil == undefined || isNaN(this.relatorioParaAdicionar.valorContabil)) {
        this.relatorioParaAdicionar.valorContabil = 0;
      }

      if (this.relatorioParaAdicionar.valorAquisicoes == "" || this.relatorioParaAdicionar.valorAquisicoes == null || this.relatorioParaAdicionar.valorAquisicoes == undefined || isNaN(this.relatorioParaAdicionar.valorAquisicoes)) {
        this.relatorioParaAdicionar.valorAquisicoes = 0;
      }

      if (this.relatorioParaAdicionar.valorConsumo == "" || this.relatorioParaAdicionar.valorConsumo == null || this.relatorioParaAdicionar.valorConsumo == undefined || isNaN(this.relatorioParaAdicionar.valorConsumo)) {
        this.relatorioParaAdicionar.valorConsumo = 0;
      }

      let relatorioNovo = {
        "id": 0,
        "valorContabil": this.relatorioParaAdicionar.valorContabil,
        "valorContabilFinal": this.relatorioParaAdicionar.valorContabilFinal,
        "valorAquisicoes": this.relatorioParaAdicionar.valorAquisicoes,
        "valorConsumo": this.relatorioParaAdicionar.valorConsumo,
        "item": this.relatorioParaAdicionar.item,
        "codigoConta": this.relatorioParaAdicionar.codigoConta,
        "descricaoConta": this.relatorioParaAdicionar.descricaoConta,
        "idModuloAnalise": 0

      }

      if (this.objetoEdit) {
        let index = this.listaDados.indexOf(this.objetoEdit);
        this.listaDados.splice(index, 1);

        relatorioNovo.id = this.objetoEdit.id;

        this.listEdit.push(this.objetoEdit);
      }

      this.listaDados.push(relatorioNovo);
      
      this.totalizarValores();
      
      this.objetoEdit = null;

      this.selecionarTodosChecked = false;

      this.relatorioParaAdicionar.valorContabil = '';
      this.relatorioParaAdicionar.valorContabilFinal = '';
      this.relatorioParaAdicionar.valorAquisicoes = '';
      this.relatorioParaAdicionar.item = '';
      this.relatorioParaAdicionar.conta = '';
      this.relatorioParaAdicionar.codigoConta = '';
      this.relatorioParaAdicionar.descricaoConta = '';
      this.relatorioParaAdicionar.valorConsumo = '';

      this.salvar(true);
    }
    else {
      this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
      return;

    }

  }

  remover(item, edit) {

    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
        if (callback) {

          let index = this.listaDados.indexOf(item);
          this.listaDados.splice(index, 1);

          if (item.id != "0") {
            this.materiaisService.removerMateriaisConsumo(item.id).subscribe(data => {
            }, error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro:" + error);
              this.carregarDados();
            });
          }
        }
      });
    } else {
      let index = this.listaDados.indexOf(item);

      if (item.id != "0" || item.id != undefined) {
        this.materiaisService.removerMateriaisConsumo(item.id).subscribe(data => {
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro:" + error);
          this.carregarDados();
        });
      }
    }
  }

  excluirSelecionados(){

    let qtdeSelecionados = 0; 
    this.listaDados.forEach(item => qtdeSelecionados += item.checked);
    
    if(qtdeSelecionados == 0) {
        this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
        return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
        "Deseja continuar com a exclusão de " 
            + registrosTexto + "<br/>" 
            + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
        callback => {            
            if (callback) {
                this.loading = true;
                                    
                let listaId = this.listaDados
                    .filter(item => item.checked)
                    .map(item => item.id);
                
                this.materiaisService.deletarMateriaisConsumoLista(listaId).subscribe(data => {
                    this.loading = false;
                    this.carregarDados();
                    this.alertService.mostraAlerta("", data.mensagem);
                }, error => {
                    this.loading = false;
                    this.carregarDados();
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                });
            }
        }
    );        
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaMateriais() {
    this.menuService.redirecionarPagina(this.materiaisService.obterIdPaginaMateriais());
  }

  salvar(add) {
    this.loading = true;

    // this.listEdit.forEach(item => {
    //   this.remover(item, true);
    // });

    this.listEdit = [];

    this.materiaisService.salvarMateriaisConsumo(this.listaDados).subscribe(data => {
      if (!add) {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
      } else {
        console.log("Salvo com sucesso...");
      }
      this.carregarDados();

    }, error => {
      if (!add) {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      } else {
        console.log("Ocorreu um erro ao salvar...");
      }
      this.loading = false;
    })
  }

  finalizar() {
    this.loading = true;

    this.listEdit.forEach(item => {
      this.remover(item, true);
    });

    this.listEdit = [];

    if (this.listaDados) {
      this.materiaisService.finalizarMateriaisConsumo(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.loading = false;
        this.voltarParaMateriais();
        // this.loading = false;
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
        this.loading = false;
      });
    }
  }

  editar(item) {
    this.relatorioParaAdicionar.valorContabil = item.valorContabil;
    this.relatorioParaAdicionar.valorContabilFinal = item.valorContabilFinal;
    this.relatorioParaAdicionar.valorAquisicoes = item.valorAquisicoes;
    this.relatorioParaAdicionar.item = item.item;
    this.relatorioParaAdicionar.conta = item.conta;
    this.relatorioParaAdicionar.codigoConta = item.codigoConta;
    this.relatorioParaAdicionar.descricaoConta = item.descricaoConta;
    this.relatorioParaAdicionar.valorConsumo = item.valorConsumo;

    this.objetoEdit = item;
  }

  printData() {

    var doc = new jsPDF("l");

    var totalPagesExp = "{total_pages_count_string}";

    this.materiaisService.listarMateriaisConsumo().subscribe(listaCompleta => {
      var pageContent = function (data) {
        // HEADER
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');

        doc.text("Inventário Sintético de Material de Consumo", data.settings.margin.left + 15, 22);

        // FOOTER
        var str = "Page " + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + " of " + totalPagesExp;
        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
      };

      var columns = [
        { title: "Espec. Item", dataKey: "item" },
        { title: "Cod. Conta", dataKey: "conta" },
        { title: "Desc. Conta", dataKey: "descConta" },
        { title: "Valor Inical", dataKey: "valorInicial" },
        { title: "Valor Total Aquisições", dataKey: "valorTotalAq" },
        { title: "Valor Total Consumo", dataKey: "valorTotalCons" },
        { title: "Valor Final", dataKey: "valorFinal" }
      ];

      let rows = [];

      listaCompleta.forEach(element => {
        var item = {
          "item": element.item != null ? element.item : "",
          "conta": element.codigoConta != null ? element.codigoConta : "",
          "descConta": element.descricaoConta != null ? element.descricaoConta : "",
          "valorInicial": element.valorContabil != null ? this.formatarValorNumerico(element.valorContabil) : "",
          "valorTotalAq": element.valorAquisicoes != null ? this.formatarValorNumerico(element.valorAquisicoes) : "",
          "valorTotalCons": element.valorConsumo != null ? this.formatarValorNumerico(element.valorConsumo) : "",
          "valorFinal": element.valorContabilFinal != null ? this.formatarValorNumerico(element.valorContabilFinal) : ""
        };

        rows.push(item);
      });

      doc.autoTable(columns, rows, {
        //   theme: 'grid',
        //   addPageContent: pageContent,
        //   margin: { top: 30 },
        //   styles: {
        //       overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
        //       columnWidth: 'auto'
        //   }
        // });

        theme: 'grid',
        addPageContent: pageContent,
        margin: {
          top: 30,
          left: 5
        },
        styles: {
          overflow: 'linebreak',
          columnWidth: 'wrap',
          fontSize: 9
        },
        columnStyles: {
          text: { columnWidth: 'wrap' },
          item: {
            columnWidth: 62,
          },
          conta: {
            columnWidth: 62
          },
          descConta: {
            columnWidth: 62
          },
          valorInical: {
            columnWidth: 25
          },
          valorTotalAq: {
            columnWidth: 25
          },
          valorTotalCons: {
            columnWidth: 25
          },
          valorFinal: {
            columnWidth: 25
          }
        }
      });

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }

      doc.save('inventario_bens_consumo.pdf');
    });
  }

  totalizarValores() {
    this.totalValorContabil = 0;
    this.totalValorAquisicoes = 0;
    this.totalValorConsumo = 0;
    this.totalValorContabilFinal = 0;

    this.listaDados.forEach(element => {
      this.totalValorContabil += element.valorContabil;
      this.totalValorAquisicoes += element.valorAquisicoes;
      this.totalValorConsumo += element.valorConsumo;
      this.totalValorContabilFinal += element.valorContabilFinal;
    });    
  }

  selecionarTodos(){
    setTimeout(()=>{
        this.listaDados.forEach(
            item => item.checked = this.selecionarTodosChecked);            
    });
  }

  selecionarItem(){
    const totalItems = this.listaDados.length;
    let checked = 0;
    this.listaDados.map(obj => {
        if (obj.checked) checked++;
    });
    this.selecionarTodosChecked = checked == totalItems;
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/materiais-consumo/materiais-consumo.ts